<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-搜索结果">
    <div class="content">
      <div class="tswrapper" v-if="paginations.total>0">
        <h1>
          查询到关于<span>“{{ $route.query.keyword }}”</span>的内容共<span>{{paginations.total}}</span>条
        </h1>
        <div class="tscontent">
          <div class="tsbox" v-for="(item, index) in newsData" :key="index">
            <h3 @click="$router.push(`/mNewsContent/${item.id}`)">
              {{ item.name }}
            </h3>
            <div class="tstime">
              <p>时间 : {{ item.putime }}</p>
              <p>浏览量 : {{ item.countpublic }}</p>
            </div>
          </div>
        </div>
        <!-- <div class="tspage" > -->
        <div class="tspage" v-if="paginations.total > paginations.page_size">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="paginations.page_index"
            :page-size="paginations.page_size"
            :total="paginations.total"
            layout="prev, pager, next"
          ></el-pagination>
        </div>
      </div>
      <div class="res" v-else>
        <h3>
          未查询到关于<span>“{{ $route.query.keyword }}”</span>的内容
        </h3>
      </div>
    </div>
  </div>
</template>
<script>
import { getKeywordNews } from "@/api/news.js";
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
      newsData: [],
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 330, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getData();
    Bus.$on("getpSearch", (e) => {
      this.getData();
    });
  },
  methods: {
    async getData() {
      let news = new FormData();
      news.append("page", this.paginations.page_index);
      news.append("rows", this.paginations.page_size);
      news.append("school", this.$route.query.keyword);
      let note = await getKeywordNews(news);
      this.paginations.total = note.total;
      this.newsData = note.rows;
    },
    // 分页
    handleCurrentChange(val) {
      this.paginations.page_index = val;
      this.getData();
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  margin-top: 150px;
  padding: 30px 0 80px;
  background-color: #ebebeb;

  .content {
    .tswrapper {
      width: calc(100vw - 60px);
      margin: 0 auto;
      h1{
        margin: 20px 10px 40px;
        font-size: 30px;
        span{
          color: red;
        }
      }
      .tscontent {
        width: 100%;
        .tsbox {
          width: calc(100% - 80px);
          background-color: #fff;
          border-radius: 10px;
          padding: 30px 40px;
          margin-bottom: 20px;
          h3 {
            font-size: 28px;
            color: #333;
            cursor: pointer;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
            &:hover {
              text-decoration: underline;
            }
          }
          .tstime {
            margin: 20px 0;
            display: flex;
            justify-content: space-between;
            p {
              font-size: 14px;
              color: #d0d0d0;
            }
          }
        }
      }
      .tspage {
        margin-top: 40px;
        text-align: center;
        /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: #fd7a3a;
          border: none;
        }
        /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
          background-color: #fff; // 进行修改未选中背景和字体
          padding: 0 14px;
          font-size: 26px;
          height: 50px;
          line-height: 50px;
          margin: 0 10px;
          // color: #fff;
        }
        /deep/ .el-pagination.is-background button {
          background-color: #fff; // 进行修改未选中背景和字体
          border: 1px solid #ededed;
          font-size: 26px;
          height: 50px;
          line-height: 50px;
          padding: 0 10px;
          // color: #fff;
        }
      }
    }
    .res {
      margin: 60px auto;
      text-align: center;
      font-size: 16px;
      span {
        color: red;
      }
    }
  }
}
</style>